<template>
    <f-dialog
        v-model       = "value"
        :show-header  = "true"
        :full-screen  = "false"
        :hide-actions = "false"
        :width        = "500"
        :show-save    = "enableUpload"
        :title        = "$t('inb.upload.typeSelect.title')"
        :store-label  = "$t('inb.upload.typeSelect.confirm')"
        @store        = "onConfirm"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <div class="mt-2">
                <div class="lm-border pa-3 mt-3">
                    <v-row dense>
                        <v-col>
                            {{ $t('inb.upload.typeSelect.hint', [fileNames.length]) }}
                        </v-col>
                    </v-row>
                    <v-row dense v-if="fileNames.length">
                        <v-col>
                            <ul class="file-list">
                                <li v-for="(name, index) in visibleFileNames" :key="index">
                                    {{ name }}
                                </li>
                            </ul>
                            <a v-if="hiddenCount > 0" @click="expanded = true">
                                {{ $t('inb.upload.typeSelect.showMore', [hiddenCount]) }}
                            </a>
                            <a v-else-if="expanded && fileNames.length > collapsedCount" @click="expanded = false">
                                {{ $t('inb.upload.typeSelect.showLess') }}
                            </a>
                        </v-col>
                    </v-row>
                </div>
                <div class="lm-border pa-3 mt-3">
                    <inb-message-types
                        v-model = "selectedType"
                        :label  = "$t('inb.upload.typeSelect.label')"
                    />
                </div>
            </div>
        </template>
    </f-dialog>
</template>

<script>
import FDialog from "@/modules/core/components/utils/FDialog";
import InbMessageTypes from "@/modules/inb/components/controlls/InbMessageTypes";

const STORAGE_KEY = "inb.upload.lastType";

export default {
    name: "DUploadTypeSelect",

    components: {
        FDialog,
        InbMessageTypes
    },

    props: {
        value: {

        },

        files: {

        }
    },

    data: () => ({
        selectedType: null,
        expanded    : false,
        collapsedCount: 20,
    }),

    computed: {
        fileNames () {
            return Array.from(this.files || []).map(file => file.name);
        },

        visibleFileNames () {
            return this.expanded ? this.fileNames : this.fileNames.slice(0, this.collapsedCount);
        },

        hiddenCount () {
            return this.expanded ? 0 : Math.max(0, this.fileNames.length - this.collapsedCount);
        },

        enableUpload () {
            return !!this.selectedType;
        }
    },

    watch: {
        value (open) {
            if (open) {
                this.expanded = false;
                this.initSelection();
            }
        }
    },

    methods: {
        initSelection () {
            const stored = sessionStorage.getItem(STORAGE_KEY);
            this.selectedType = stored ? JSON.parse(stored) : null;
        },

        onConfirm () {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.selectedType));
            this.$emit("confirm", this.selectedType);
            this.$emit("input", false);
        },

        onCancel () {
            this.$emit("cancel");
            this.$emit("input", false);
        }
    }
}
</script>

<style scoped>
.file-list {
    margin: 0;
    padding-left: 20px;
    max-height: 220px;
    overflow-y: auto;
}
</style>
